import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { 
  Sprout, 
  Apple, 
  Flower2, 
  Trees, 
  Leaf 
} from "lucide-react";

const TargetAudience: React.FC = () => {
  const { t } = useLanguage();
  
  const uses = [
    {id: 1, name: t('target.veg'), icon: Sprout },
    {id: 2, name: t('target.fruits'), icon: Apple },
    {id: 3, name: t('target.flowers'), icon: Flower2 },
    {id: 4, name: t('target.lawns'), icon: Trees },
    {id: 5, name: t('target.nurseries'), icon: Leaf }
    // {id: 6, name: t('target.pots'), icon: 'potted_plant1' } - Lucide doesn't have a potted plant icon yet
  ];
  
  return (
    <section className="py-16 bg-primary/5">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h3 className="text-3xl font-extrabold mb-8 text-emerald-900 dark:text-white">
          {t('target.title')}
        </h3>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 ">
          {uses.map((use, index) => {
            const IconComponent = use.icon;
            return (
              <div 
                key={index} 
                className="flex flex-col items-center group "
              >
                <div className="w-20 h-20 md:w-24 md:h-24 bg-white dark:bg-emerald-950 rounded-2xl flex items-center justify-center mb-3 shadow-lg group-hover:shadow-xl group-hover:scale-105 transition-all duration-300 group-hover:bg-primary/10 border-2">
                  <IconComponent className="text-primary w-8 h-8 md:w-10 md:h-10" />
                </div>
                <div className="font-bold text-lg text-emerald-900 dark:text-white group-hover:text-primary transition-colors">
                  {use.name}
                </div>
              </div>
            );
          })}
        </div>
        <p className="mt-12 text-lg text-emerald-800/70 dark:text-emerald-100/60 max-w-3xl mx-auto">
          {t('target.description')}
        </p>
      </div>
    </section>
  );
};

export default TargetAudience;